import { AuthContextProps } from "../components/auth-context";
import { deleteData, getData, postData } from "./core";

export default class PurchaseTicketApi {
  static uri = "a/internet/PurchaseTicket";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  getAll() {
    return getData({
      uri: PurchaseTicketApi.uri,
      context: this.context,
    });
  }

  post(
  fileId: number,
  productType: number,
  productId: number,
  selectedProducts?: number[],
  shippingId?: number,
  count?: number
) {
  return postData({
    uri: PurchaseTicketApi.uri,
    data: {
      fileId,
      productId,
      productType,
      selectedProducts,
      shippingId,
      count,
    },
    context: this.context,
  });
}


  delete(id: string) {
    return deleteData({
      uri: PurchaseTicketApi.uri,
      id: id,
      context: this.context,
    });
  }

  get(id: any) {
    return getData({
      uri: PurchaseTicketApi.uri,
      id: id,
      context: this.context,
    });
  }
}
